<div class="create-organisation">
    <!-- Form Container -->
    <div class="container-custom">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <app-breadcrumb [breadcrumbItems]="breadcrumbItems"></app-breadcrumb>
            </div>
            <span class="fa fa-times" (click)="closeModal()" role="button"></span>
        </div>
        <div class="d-flex justify-content-between align-items-center organisation-header">
            <div>
                <span class="title">{{ organisationId ? 'Update' : 'Create' }} Organization</span>
            </div>
            <span class="step-info">Step 1 of 3</span>
        </div>
        <div class="my-4">
            <p>Please fill the below information to create an organization.</p>
        </div>
        <!-- Form Fields -->
        <form [formGroup]="organisationForm" (ngSubmit)="onSubmit()">
            <div class="row g-3">
                <div class="col-md-6">
                    <label class="form-label">Organization Name*</label>
                    <input type="text" class="form-control" placeholder="Enter Organization Name"
                        formControlName="name">
                    <small *ngIf="organisationForm.get('name')?.invalid && organisationForm.get('name')?.touched"
                        class="text-danger">
                        <span *ngIf="organisationForm.get('name')?.errors?.['required']">Organization name is
                            required.</span>
                        <span *ngIf="organisationForm.get('name')?.errors?.['maxlength']">Organization name cannot
                            exceed 50 characters.</span>
                    </small>
                </div>
                <div class="col-md-6">
                    <label class="form-label">Short Name*</label>
                    <input type="text" class="form-control" placeholder="Enter Short Name" formControlName="short_name">
                    <small
                        *ngIf="organisationForm.get('short_name')?.invalid && organisationForm.get('short_name')?.touched"
                        class="text-danger">
                        <span *ngIf="organisationForm.get('short_name')?.errors?.['required']">Short name is
                            required.</span>
                        <span *ngIf="organisationForm.get('short_name')?.errors?.['maxlength']">Short name cannot exceed
                            4 characters.</span>
                    </small>
                </div>
                <div class="col-md-6 mt-3">
                    <label class="form-label">Official Name*</label>
                    <input type="text" class="form-control" placeholder="Enter Official Name"
                        formControlName="official_name">
                    <small
                        *ngIf="organisationForm.get('official_name')?.invalid && organisationForm.get('official_name')?.touched"
                        class="text-danger">
                        <span *ngIf="organisationForm.get('official_name')?.errors?.['required']">Official name is
                            required.</span>
                        <span *ngIf="organisationForm.get('official_name')?.errors?.['maxlength']">Official name cannot
                            exceed 50 characters.</span>
                    </small>
                </div>
                <!-- <div class="col-md-6 mt-3">
                    <label class="form-label">Contact Number</label>
                    <input type="text" class="form-control" placeholder="Enter Contact Number"
                        formControlName="contact_number">
                    <small
                        *ngIf="organisationForm.get('contact_number')?.invalid && organisationForm.get('contact_number')?.touched"
                        class="text-danger">
                        <span *ngIf="organisationForm.get('contact_number')?.errors?.['required']">
                            Contact Number is required.
                        </span>
                        <span *ngIf="organisationForm.get('contact_number')?.errors?.['maxlength']">
                            Contact Number cannot exceed 50 characters.
                        </span>
                        <span *ngIf="organisationForm.get('contact_number')?.errors?.['pattern']">
                            Contact Number must be exactly 10 digits.
                        </span>
                    </small>
                </div> -->
                <!-- <div class="col-md-6 mt-3">
                    <label class="form-label">Contact Email</label>
                    <input type="email" class="form-control" placeholder="Enter Email Address"
                        formControlName="contact_email">
                  

                </div> -->
                <div class="col-md-6 mt-3">
                    <label class="form-label">GST Number</label>
                    <input type="text" class="form-control" placeholder="Enter GST Number" formControlName="gst_number">
                    <small
                        *ngIf="organisationForm.get('official_name')?.invalid && organisationForm.get('official_name')?.touched"
                        class="text-danger">
                        <span *ngIf="organisationForm.get('official_name')?.errors?.['maxlength']">GST number cannot
                            exceed 15 characters.</span>
                    </small>
                </div>
                <div class="col-md-6 mt-3">
                    <label class="form-label">Logo</label>
                    <input type="file" class="form-control" (change)="onFileSelected($event)">
                    <div *ngIf="logoPreview" class="mt-3">
                        <img [src]="logoPreview" alt="logo" class="img-thumbnail" style="width: 40px; height: 40px;">
                    </div>
                    <!-- <div *ngIf="logoError" class="text-danger">Logo is required.</div> -->
                </div>
                <div class="col-md-6 mt-3">
                    <label class="form-label">Modules*</label>
                    <app-multiselect-dropdown formControlName="selectedModules" [list]="modulesList"
                        [displayKey]="'name'" [valueKey]="'id'" placeholder="Modules">
                    </app-multiselect-dropdown>
                    <small
                        *ngIf="organisationForm.get('selectedModules')?.invalid && organisationForm.get('selectedModules')?.touched"
                        class="text-danger">
                        <span *ngIf="organisationForm.get('selectedModules')?.errors?.['required']">
                            Modules are required.
                        </span>
                    </small>
                </div>
                <div class="col-md-12 mt-3">
                    <label class="form-label">Address</label>
                    <textarea class="form-control" placeholder="Add Organization Address" rows="3"
                        formControlName="address"></textarea>
                </div>
            </div>

            <!-- Toggles -->
            <div class="mt-3">
                <div class="d-flex align-items-center mb-2">
          <label class="form-check-label me-2">Deleted Status</label>
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              formControlName="deleted"
            />
          </div>
        </div>
            </div>

            <div class="mt-3 flex-item ">
                <div class="d-flex align-items-start g-2 ">
                    <label class="form-check-label  mb-2">Auto UHID Generation</label>
                    <div class="d-flex align-items-center form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="is_uhid_generation_enabled">
                    </div>
                </div>
                <div class="d-flex align-items-start g-2">
                    <label class="form-check-label ">Teleconsult Enabled</label>
                    <div class="d-flex align-items-center form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="is_teleconsult_enabled">
                    </div>
                </div>
                <div class="d-flex align-items-start g-2">
                    <label class="form-check-label">Whatsapp Enabled</label>
                    <div class="d-flex align-items-center form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="is_whatsapp_enabled">
                    </div>
                </div>
                 <div class="d-flex align-items-start g-2">
                    <label class="form-check-label "> Is Reminder SMS Enabled</label>
                    <div class="d-flex align-items-center form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="is_reminder_sms_enabled">
                    </div>
                </div>
                <div class="d-flex align-items-start g-2">
                    <label class="form-check-label "> Is Authorization Enabled</label>
                    <div class="d-flex align-items-center form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="is_authorization_enabled">
                    </div>
                </div>
                 <div class="d-flex align-items-start g-2">
                    <label class="form-check-label "> Is Payment Status Enabled</label>
                    <div class="d-flex align-items-center form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="is_payment_status_enabled">
                    </div>
                </div>
                 <div class="d-flex align-items-start g-2">
                    <label class="form-check-label "> Is Visit Id Generation Enabled</label>
                    <div class="d-flex align-items-center form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="is_visit_id_generation_enabled">
                    </div>
                </div>
                  <div class="d-flex align-items-start g-2">
                    <label class="form-check-label "> Is Email Enabled</label>
                    <div class="d-flex align-items-center form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="is_email_enabled">
                    </div>
                </div>

                <div class="d-flex align-items-start g-2">
                    <label class="form-check-label "> Is Dummy Enabled</label>
                    <div class="d-flex align-items-center form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="dummy">
                    </div>
                </div>
                  <div class="d-flex align-items-start g-2">
                    <label class="form-check-label "> Is SMS Enabled</label>
                    <div class="d-flex align-items-center form-check form-switch">
                        <input class="form-check-input" type="checkbox" formControlName="is_sms_enabled">
                    </div>
                </div>

            </div>

            <!-- Buttons -->
            <div class="footer-buttons mt-3 mb-2">
                <button class="btn btn-save" type="submit">{{ organisationId ? 'Update' : 'Save' }}</button>
                <div class="d-flex align-items-center mt-5 gap-3" *ngIf="organisationData?.id">
                    <button class="btn btn-outline-secondary" (click)="closeModal()" type="button">Cancel</button>
                    <button class="btn btn-create" type="button" (click)="openBranchModal()">Create Branch</button>
                </div>
            </div>
        </form>
    </div>

</div>
